// Bronvex: "Complete your robot" card in the cart (snippets/bx-cart-upsell.liquid).
import { CartLinesUpdateEvent } from '@shopify/events';
if (!customElements.get('bx-upsell')) {
  customElements.define('bx-upsell', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const pill = e.target.closest('.bx-upsell__pill');
        if (pill) {
          this.querySelectorAll('.bx-upsell__pill').forEach((p) => { p.classList.toggle('is-on', p === pill); p.setAttribute('aria-checked', p === pill); });
          this.querySelector('[data-add]').dataset.id = pill.dataset.id;
        }
        if (e.target.closest('[data-add]')) this.add(e.target.closest('[data-add]'));
      });
    }
    async add(btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-busy');
      const id = btn.dataset.id;
      const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
      try {
        const res = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: location.pathname }),
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, itemCount: cart.item_count, sections: data.sections, source: 'bx-upsell', sourceId: 'bx-upsell', didError: false },
        });
        if (!document.querySelector('cart-drawer-component')) location.reload();
      } catch (err) {
        deferred.reject(err);
        btn.disabled = false;
        btn.classList.remove('is-busy');
        location.reload();
      }
    }
  });
}
